import { useLocation, useNavigate } from "react-router-dom";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import ActionButton from "../../Components/ReactDataTable/ActionButton";
import {
  CLEAR_EXPLORE_SUCCESS,
  draftExploreActiveStatus,
  getExploreDetailAction,
  publishedExploreStatus,
  searchExplore,
  RemoveExplore,
  CopyContent,
  CLEAR_EXPLORE_DATA,
} from "../../Redux/Actions/ExploreAction";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useMemo } from "react";
import moment from "moment";
import {
  Box,
  Button,
  ButtonGroup,
  Typography,
  Checkbox,
  InputLabel,
  FormControl,
  MenuItem,
  Select,
} from "@mui/material";
import { useErrorHandler } from "../../hooks";
import HelmetReact from "../../Components/Helmet";
import FilterComponent from "../../Components/ReactDataTable/FilterComponent";
import ResponsiveDialog from "../../Components/DialogBox";
import CustomTable from "../../Components/CustomTable/CustomTable";
export const Explore = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, exploreList, categories, totalCount, copy_status, success } =
    useSelector((state) => state.Explore);
  const [model, setModel] = useState("Delete");

  const [details, setDetails] = useState({ id: "", is_publish: false });
  const [tabNavigate, setTabNavigate] = useState("");
  const [selectedTab, setSelectedTab] = useState("PUBLISHED");
  const [filterBy, setFilterBy] = useState("");
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [open, setOpen] = useState(false);
  const { setMsgConfig } = useErrorHandler();
  const location = useLocation();
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [itemId, setItemId] = useState();
  const [globalFilter, setGlobalFilter] = useState("");
  const ITEM_HEIGHT = 48;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5,
      },
    },
  };
  useEffect(() => {
    dispatch({ type: CLEAR_EXPLORE_DATA });
    if (copy_status) {
      setSelectedTab("SANDBOX");
    }
    if (copy_status && selectedTab === "SANDBOX") {
      const searchPayload = {
        type: "sandbox",
        key: globalFilter || "",
        perPage: pagination?.pageSize || 10,
        page: pagination?.pageIndex + 1 || 1,
        sortBy: "order_no",
        sortDirection: "ASC",
        filter_by: filterBy || categories[0]?.name,
      };
      dispatch(searchExplore(searchPayload));
    }
  }, [copy_status]);

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  let data;
  if (exploreList?.length) {
    if (selectedTab === "PUBLISHED") {
      data = exploreList?.map((e) => e);
    } else if (selectedTab === "SANDBOX") {
      data = exploreList?.map((e) => e);
    }
  }

  const handleChange = (e) => {
    setFilterBy(e.target.value);
  };

  useEffect(() => {
    if (selectedTab === "PUBLISHED") {
      const searchPayload = {
        type: "publish",
        key: globalFilter || "",
        perPage: pagination?.pageSize || 10,
        page: pagination?.pageIndex + 1 || 1,
        sortBy: "order_no",
        sortDirection: "ASC",
        filter_by: filterBy || categories[0]?.name,
      };
      dispatch(searchExplore(searchPayload));
    } else if (selectedTab === "SANDBOX") {
      const searchPayload = {
        type: "sandbox",
        key: globalFilter || "",
        perPage: pagination?.pageSize || 10,
        page: pagination?.pageIndex + 1 || 1,
        sortBy: "order_no",
        sortDirection: "ASC",
        filter_by: filterBy || categories[0]?.name,
      };
      dispatch(searchExplore(searchPayload));
    }
  }, [pagination, selectedTab, globalFilter, filterBy, success]);

  useEffect(() => {
    location?.state === "SANDBOX"
      ? setTabNavigate("SANDBOX")
      : setTabNavigate("PUBLISHED");
    // setLoaderTimeOut(true);
    setTimeout(() => {
      // setLoaderTimeOut(false);
    }, 400);
  }, [location?.state, tabNavigate]);

  useEffect(() => {
    if (tabNavigate) {
      setSelectedTab(tabNavigate);
    }
  }, [tabNavigate]);

  const handleStatusChange = (item, value) => {
    const payload = {
      Id: item?.Id,
      is_active: value,
    };
    dispatch(draftExploreActiveStatus(payload));
    setMsgConfig({
      alertOpen: true,
      message: "Program Status Update SuccessFully!!",
      severity: "success",
      autoHideDuration: 2000,
    });
  };
  const handleAllow = () => {
    setIsVisibleModal(false);
    setModel("Delete");
    handlechecked(true);
    //write code for notification allow
  };

  const handlechecked = (notify) => {
    const payload = {
      Id: details.id,
      is_publish: details.is_publish,
      is_notify: notify,
    };
    dispatch(publishedExploreStatus(payload));
    setMsgConfig({
      alertOpen: true,
      message: "Success!!",
      severity: "success",
      autoHideDuration: 2000,
    });
  };

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e)}
        onClear={handleClear}
        filterText={filterText}
        placeHolder="Search by title"
      />
    );
  }, [filterText, resetPaginationToggle]);

  const goToDetailScreen = (id) => {
    setOpen(!open);
    dispatch(getExploreDetailAction(id.Id));
    navigate("/explore/create-content");
  };
  const RemoveItem = (item) => {
    setIsVisibleModal(true);
    setItemId(item?.Id);
  };
  const handleConfirm = () => {
    const payload = {
      Id: itemId,
    };

    dispatch(RemoveExplore(payload));
    setIsVisibleModal(false);
    setMsgConfig({
      alertOpen: true,
      message: "Remove Explore SuccessFully!!",
      severity: "success",
      autoHideDuration: 1000,
    });
  };
  const columns = [
    {
      header: "DUPLICATE",
      size: 50,
      Cell: ({ row }) => (
        <Box sx={{ cursor: "pointer" }}>
          <ContentCopyOutlinedIcon
            onClick={() => {
              if (row) {
                const payload = {
                  content_id: row.original.Id,
                  type: "explore",
                };
                dispatch(CopyContent(payload));
              }
              //Called api for copied program data
            }}
          />
        </Box>
      ),
    },
    {
      accessorKey: "title",
      header: "TITLE",
      size: 50,
    },
    {
      accessorKey: "contributor_name",
      header: "CONTRIBUTOR",
      size: 50,
    },
    {
      accessorKey: "cover_img",
      header: "COVER IMAGE",
      size: 50,
      Cell: ({ row }) => (
        <Box>
          <img
            src={row.original.cover_img}
            loading="lazy"
            width="50px"
            height="50px"
            alt="N/A"
          />
        </Box>
      ),
    },
    {
      accessorKey: "created_at",
      header: "DATE CREATED",
      size: 60,
      Cell: ({ renderedCellValue }) => (
        <span>
          {renderedCellValue
            ? moment(renderedCellValue).format("DD/MM/YYYY")
            : "N/A"}
        </span>
      ),
    },
    {
      accessorKey: "is_publish",
      header: "STATUS",
      size: 60,
      Cell: ({ renderedCellValue, row, cell }) => (
        <>
          <div className="badge bg-light-danger">
            <Typography>Published</Typography>

            <Checkbox
              checked={renderedCellValue}
              onChange={(e) => {
                setDetails({
                  id: row.original.Id,
                  is_publish: e.target.checked,
                });
                if (renderedCellValue) {
                  dispatch(
                    publishedExploreStatus({
                      Id: row.original.Id,
                      is_publish: e.target.checked,
                    })
                  );
                  setMsgConfig({
                    alertOpen: true,
                    message: "Success!!",
                    severity: "success",
                    autoHideDuration: 2000,
                  });
                } else {
                  setModel("Published");
                  setIsVisibleModal(true);
                }
              }}
            />
          </div>
        </>
      ),
    },
    {
      accessorKey: "is_active",
      header: "EXPLORE STATUS",
      size: 60,
      Cell: ({ renderedCellValue, row }) => (
        <>
          <Box sx={{ display: "flex", gap: "10px" }}>
            <span className="badge bg-light-danger">
              <span className="status">
                {renderedCellValue === true ? "Active" : "Inactive"}
              </span>
            </span>
            <span className="status-icon-btn view-detail-btn">
              <ActionButton
                isUpdateIcon={true}
                handleStatusChange={handleStatusChange}
                item={row.original}
                isEditMode={true}
              />
            </span>
          </Box>
        </>
      ),
    },
    {
      header: "ACTION",
      size: 60,
      Cell: ({ row }) => (
        <>
          <Box sx={{ display: "flex" }}>
            {selectedTab !== "PUBLISHED" ? (
              <span className="edit-icon-btn view-detail-btn">
                <ActionButton
                  isEditIcon={true}
                  goToDetailScreen={goToDetailScreen}
                  item={row.original}
                  isEditMode={true}
                />
              </span>
            ) : (
              ""
            )}
            <span className="remove-icon-btn view-detail-btn">
              <ActionButton
                isRemoveIcon={true}
                RemoveItem={RemoveItem}
                item={row.original}
                isEditMode={true}
              />
            </span>
          </Box>
        </>
      ),
    },
  ];

  return (
    <>
      <ResponsiveDialog
        dtype={model === "Published" ? "permission" : "confirm"}
        open={isVisibleModal}
        header={
          model === "Published"
            ? "Do you want to notify users of publishing?"
            : "Are you sure you want to delete this program?"
        }
        onConfirm={() =>
          model === "Published" ? handleAllow() : handleConfirm()
        }
        onClose={() => {
          if (model === "Published") {
            setModel("Delete");
            handlechecked(false);
          }
          setIsVisibleModal(false);
        }}
      ></ResponsiveDialog>
      <HelmetReact name="Explore Content" />
      <Box className="d-details-box">
        <ButtonGroup variant="text" aria-label="text button group">
          <Button
            className={`${selectedTab === "PUBLISHED" ? "active" : ""}`}
            onClick={() => {
              // setLoaderTimeOut(true);
              setTimeout(() => {
                // setLoaderTimeOut(false);
              }, 1000);
              setSelectedTab("PUBLISHED");
              setFilterText("");
            }}
          >
            PUBLISHED
          </Button>

          <Button
            className={`${selectedTab === "SANDBOX" ? "active" : ""}`}
            onClick={() => {
              // setLoaderTimeOut(true);
              setTimeout(() => {
                // setLoaderTimeOut(false);
              }, 1000);
              setSelectedTab("SANDBOX");
              setFilterText("");
            }}
          >
            SANDBOX
          </Button>
        </ButtonGroup>
        {/* <List component={Stack} direction="row"></List> */}
        <Box
          sx={{
            textAlign: "right",
          }}
        >
          <FormControl sx={{ m: 1, minWidth: 80, bottom: "16px", }}>
            <InputLabel id="demo-simple-select-autowidth-label">
              Category
            </InputLabel>
            <Select
              MenuProps={MenuProps}
              labelId="demo-simple-select-autowidth-label"
              id="demo-simple-select-autowidth"
              onChange={handleChange}
              defaultValue={categories[0]?.name}
              autoWidth
              variant="standard"
              disableUnderline
              label="Category"
            >
              {categories?.length > 0 &&
                categories?.map((item, index) => {
                  return (
                    <MenuItem key={index} value={item.name}>
                      {item.name}
                    </MenuItem>
                  );
                })}
            </Select>
          </FormControl>
          <Button
            sx={{
              background: "#000",
              marginBottom: "15px",
              borderRadius: "70px",
            }}
            variant="contained"
            onClick={(e) => {
              e.stopPropagation();
              dispatch({ type: CLEAR_EXPLORE_SUCCESS });
              navigate("/explore/create-content");
            }}
          >
            CREATE CONTENT
          </Button>
        </Box>
        {/* {loaderTimeOut ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mt: 15,
            }}
          >
            <ReactLoading
              type="cylon"
              height="80px"
              width="80px"
              color="#39a2e8"
            />
          </Box>
        ) : (
          <> */}
        {/* <ReactDataTable
          columns={columns}
          items={data}
          onChange={onTableChange}
          paginationTotalRows={totalCount}
          isLoading={loading}
          navigateUrl={navigateUrl}
          isShowSearch={true}
          paginationResetDefaultPage={resetPaginationToggle}
          subHeader
          subHeaderComponent={subHeaderComponentMemo}
        /> */}
        <CustomTable
          data={data || []}
          columns={columns}
          loading={loading}
          manualPagination
          totalRecords={totalCount}
          onPaginationChange={setPagination}
          pagination={pagination}
          globalFilter={globalFilter}
          onGlobalFilterChange={setGlobalFilter}
        />
      </Box>
    </>
  );
};
